import {
  IPlatformAppEvent,
  IPlatformPrivateEvent,
  PlatformPrivateEventEmitter,
} from '@wix/public-editor-platform-events';

import { PlatformWorkerStrategy } from './WorkerStrategy';
import { Essentials, biEventSteps } from './Essentials';
import { PlatformFrameStrategy } from './PlatformFrameStrategy';
import { IPrivateAPI } from '@wix/editor-platform-private-api';

/**
 * This code is executed within the main thread
 * TODO: rename this service, probably we should handle this as soon as we move this code into new repo
 */
export class PlatformWorkerManager {
  public essentials: Essentials;

  constructor(
    /**
     * NOTE: we need better separate PS and PrivateAPI
     * probably all internal infra should depend on PS instead of private API
     */
    private privateAPI: IPrivateAPI,
    private workerStrategy: PlatformWorkerStrategy,
    private frameStrategy: PlatformFrameStrategy,
    public events: PlatformPrivateEventEmitter,
  ) {
    this.essentials = new Essentials({
      bi: {
        metaSiteId: this.privateAPI.info.getMetaSiteId(),
        userId: this.privateAPI.info.getUser(),
        editorSessionId: this.privateAPI.info.getEditorSessionId(),
        editorType: this.privateAPI.info.getEditorType(),
        sdkVersion: '2.0',
      },
    });

    // TODO: rename – subscribeToExternalEvents()?
    this.subscribeOnPrivateEvents();
    this.subscribeOnAppEvents();
  }

  private reportBiEvent(event: IPlatformPrivateEvent | IPlatformAppEvent) {
    if (!event.meta.bi) {
      return;
    }

    if (event.meta.error && event.meta.step === biEventSteps.error) {
      this.essentials.bi.reportError({
        ...event.meta.bi,
        error: event.meta.error,
      });
    } else {
      this.essentials.bi.reportBi({
        ...event.meta.bi,
        step: event.meta.step,
      });
    }
  }

  private subscribeOnPrivateEvents() {
    this.events.subscribe((event) => {
      this.reportBiEvent(event);
      /**
       * translate events into worker
       */
      this.workerStrategy.forEachWorker((workerAPI) => {
        void workerAPI.notify(event);
      });

      this.frameStrategy.notify(event);
    });
  }

  private subscribeOnAppEvents() {
    this.workerStrategy.onWorkerEvent((event) => {
      this.reportBiEvent(event);
    });
  }

  public getWorkerAPI() {
    return this.workerStrategy.getWorkerAPI();
  }

  public async connectFrame(
    appDefinitionId: string, // spec
    iframe: HTMLIFrameElement,
  ) {
    return this.frameStrategy.connect(appDefinitionId, iframe);
  }
}
